import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        accent: colors.blue.darken2,
        content: colors.deepOrange.darken3,
        device: colors.lightBlue.darken1,
        group: colors.orange.darken1,
        info: colors.cyan.base,
        log: colors.indigo.lighten2,
        playlist: colors.lightGreen.darken3,
        primary: colors.pink.base,
        schedule: colors.deepPurple.lighten1,
        secondary: colors.blue.darken1,
        unit: colors.green.darken1,
        user: colors.purple.lighten3
      },
      light: {
        accent: colors.blue.darken2,
        content: colors.deepOrange.darken3,
        device: colors.lightBlue.darken1,
        group: colors.orange.darken2,
        info: colors.cyan.base,
        log: colors.indigo.lighten2,
        playlist: colors.lightGreen.darken1,
        primary: colors.pink.base,
        schedule: colors.deepPurple.lighten1,
        secondary: colors.blue.darken1,
        unit: colors.green.darken2,
        user: colors.purple.lighten3
      }
    }
  }
})
